import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
function mapVessel(v) {
    let trendClass = "text-muted";
    let trendIcon = "";
    if (v.TrendPercentage !== null) {
        if (v.TrendPercentage > 0) {
            trendClass = "text-danger";
            trendIcon = "\u25B2";
        }
        else if (v.TrendPercentage < 0) {
            trendClass = "text-success";
            trendIcon = "\u25BC";
        }
    }
    let crewTrendIcon = "";
    if (v.CrewComplementTrend === true)
        crewTrendIcon = "\u25B2";
    else if (v.CrewComplementTrend === false)
        crewTrendIcon = "\u25BC";
    else
        crewTrendIcon = "=";
    return {
        vesselName: v.VesselName,
        totalNcDays: v.TotalNcDays,
        trendDisplay: v.TrendPercentage !== null ? `${Math.abs(v.TrendPercentage)}%` : "N/A",
        trendClass,
        trendIcon,
        highestNcLevel: v.HighestNcLevel,
        levelClass: `badge-l${v.HighestNcLevel}`,
        crewComplement: v.CurrentCrewComplement !== null ? v.CurrentCrewComplement : "N/A",
        crewTrendIcon: v.CurrentCrewComplement !== null ? crewTrendIcon : "",
        unreviewedNcCount: v.UnreviewedNcCount,
    };
}
export function VesselsAttentionTable({ options }) {
    const [isFetching, setIsFetching] = useState(false);
    const [hasResult, setHasResult] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [vessels, setVessels] = useState([]);
    const isLoading = !options.isReady || isFetching;
    useEffect(() => {
        if (!options.isReady) {
            setHasResult(false);
            setIsFetching(false);
            setErrorMessage("");
            return;
        }
        setIsFetching(true);
        setHasResult(false);
        setErrorMessage("");
        const params = new URLSearchParams();
        params.append("year", String(options.year));
        params.append("quarter", String(options.quarter));
        options.fleetIds.forEach((id) => params.append("fleetIds", String(id)));
        fetch(`/api/insights/vessels/attention?${params}`)
            .then((res) => {
            if (res.status === 204)
                return null;
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((data) => {
            setVessels(data === null ? [] : data.map(mapVessel));
            setHasResult(true);
        })
            .catch((e) => {
            console.error(e);
            setErrorMessage("Error fetching vessels requiring attention");
        })
            .finally(() => setIsFetching(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options.isReady, options.year, options.quarter, options.fleetIds.join(",")]);
    return (_jsxs("div", { className: "card shadow h-100", children: [_jsx("h3", { className: "card-header", children: "Vessels with highest NCs" }), _jsxs("div", { className: "card-body", children: [isLoading && (_jsxs("div", { className: "text-center py-4", children: [_jsx("span", { className: "spinner-grow spinner-grow-sm", role: "status", "aria-hidden": "true" }), " Loading..."] })), options.isReady && errorMessage && (_jsx("div", { className: "alert alert-danger", role: "alert", children: errorMessage })), hasResult && !isLoading && vessels.length > 0 && (_jsx("div", { className: "table-responsive", children: _jsxs("table", { className: "table table-sm align-middle mb-0", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Vessel" }), _jsx("th", { className: "text-end", children: "NC Days" }), _jsx("th", { className: "text-end", children: "Trend" }), _jsx("th", { className: "text-center", children: "Highest Level" }), _jsx("th", { className: "text-end", children: "Crew Complement" }), _jsx("th", { className: "text-end", children: "Unreviewed NCs" })] }) }), _jsx("tbody", { children: vessels.map((v, index) => (_jsxs("tr", { children: [_jsx("td", { children: v.vesselName }), _jsx("td", { className: "text-end", children: v.totalNcDays }), _jsx("td", { className: "text-end", children: _jsxs("span", { className: v.trendClass, children: [_jsx("span", { children: v.trendIcon }), " ", _jsx("span", { children: v.trendDisplay })] }) }), _jsx("td", { className: "text-center", children: _jsx("span", { className: `badge rounded-pill ${v.levelClass}`, children: `L${v.highestNcLevel}` }) }), _jsxs("td", { className: "text-end", children: [_jsx("span", { children: v.crewComplement }), _jsx("span", { className: "ms-1", children: v.crewTrendIcon })] }), _jsx("td", { className: "text-end", children: v.unreviewedNcCount })] }, index))) })] }) })), hasResult && !isLoading && vessels.length === 0 && (_jsx("p", { className: "text-muted mb-0", children: "No data available for this period." }))] })] }));
}
